import { useEffect } from "react";

// Site-wide subtle scroll reveal: fades + lifts each <section> as it enters view.
export default function useScrollReveal(deps = []) {
  useEffect(() => {
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;

    const nodes = Array.from(
      document.querySelectorAll("main section:not([data-no-reveal])")
    );
    if (!nodes.length) return;

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("is-revealed");
            observer.unobserve(entry.target);
          }
        });
      },
      { rootMargin: "0px 0px -8% 0px", threshold: 0.04 }
    );

    nodes.forEach((node, i) => {
      // The first section (hero) plays its own entrance animation
      if (i === 0) {
        node.classList.add("is-revealed");
        return;
      }
      node.classList.add("reveal-section");
      observer.observe(node);
    });

    return () => observer.disconnect();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, deps);
}
